import { render, staticRenderFns } from "./resoure.vue?vue&type=template&id=071898fe&"
import script from "./resoure.vue?vue&type=script&lang=js&"
export * from "./resoure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports